import styled from "styled-components";
import Colors from "../../constants/Colors";
import {deviceMax, deviceMin} from "../../../styles/device";

export const ContactContentWrapper = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  background: ${Colors.white};
  border-radius: 6px;
  padding: 23px 40px;

  @media ${deviceMax.tablet} {
    padding-left: 0;
    padding-right: 0;
    background: transparent;
  }

  > .contact-content-row {
    @media ${deviceMin.laptopL} {
      max-width: 1450px;
      margin: 0 auto;
    }
  }

  h2 {
    margin-top: 0;
    text-transform: uppercase;
    color: ${Colors.brandColor};

    @media ${deviceMax.tablet} {
      color: ${Colors.black};
      text-align: center;
      margin: 0 auto 24px;
    }
  }

  .container {
    position: relative;
    display: flex;
    flex-direction: row;
    margin-top: 20px;

    @media ${deviceMax.tablet} {
      flex-direction: column;
    }

    > .wrapper {
      position: relative;
      display: flex;
      flex-direction: row;

      @media ${deviceMax.mobileM} {
        flex-direction: column;
      }

      > .pp-contact-info {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        margin-right: 90px;

        @media ${deviceMax.mobileM} {
          margin-right: 0;
          align-items: center;
        }

        @media ${deviceMax.tablet} {
          margin-right: 0;
          padding-bottom: 21px;
        }


        @media ${deviceMin.tablet} and ${deviceMax.laptopS} {
          justify-content: flex-start;
          margin-right: 30px;
        }

        > .info-wrapper {
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          margin-bottom: 30px;

          @media ${deviceMax.mobileM} {
            flex-direction: column;
          }

          &:last-child {
            margin-bottom: 0;
          }

          > .icon {
            min-width: 90px;
            margin-right: 60px;
            text-align: center;

            @media ${deviceMin.tablet} and ${deviceMax.laptopS} {
              margin-right: 30px;
            }

            @media ${deviceMax.tablet} {
              margin-right: 28px;
            }
            @media ${deviceMax.mobileM} {
              margin-right: 0;
              margin-bottom: 14px;
            }
          }

          > .contact-content {
            position: relative;
            display: flex;
            flex-direction: column;

            @media ${deviceMax.mobileM} {
              align-items: center;
            }

            > .title {
              font-family: 'Manrope', sans-serif;
              font-weight: 400;
              font-size: 18px;
              line-height: 30px;
              letter-spacing: 0;
              text-transform: capitalize;
              color: ${Colors.black};

              @media ${deviceMax.tablet} {
                font-size: 16px;
                line-height: 24px;
              }
              @media ${deviceMin.tablet} and ${deviceMax.laptopS} {
                font-size: 16px;
                line-height: 24px;
              }
            }

            > .detail {
              font-family: 'Manrope', sans-serif;
              font-weight: 800;
              font-size: 18px;
              line-height: 30px;
              letter-spacing: 0;
              color: ${Colors.black};

              @media ${deviceMax.tablet} {
                font-size: 16px;
                line-height: 24px;
              }
              @media ${deviceMin.tablet} and ${deviceMax.laptopS} {
                font-size: 16px;
                line-height: 24px;
              }
              
              > a {
                text-decoration: none;
                display: block;
              }
            }
          }
        }

      }

      > .pp-contact-company-detail {
        position: relative;
        padding-left: 55px;
        border-left: 1px solid ${Colors.black};

        @media ${deviceMax.tablet} {
          border-left: none;
          padding-left: 0;
          border-top: 1px solid ${Colors.black};
          padding-top: 21px;
        }

        > .pp-contact-address {
          position: relative;
          display: flex;
          flex-direction: column;

          > .company-info {
            position: relative;
            display: flex;
            flex-direction: column;
            border-bottom: 1px solid ${Colors.black};

            > .company-text {
              font-family: 'Manrope', sans-serif;
              font-weight: 400;
              font-size: 18px;
              line-height: 30px;
              letter-spacing: 0;
              text-transform: capitalize;
              color: ${Colors.black};
              margin-bottom: 20px;

              @media ${deviceMax.tablet} {
                font-size: 16px;
                line-height: 24px;
              }

              &:last-child {
                margin-bottom: 50px;

                @media ${deviceMax.tablet} {
                  margin-bottom: 20px;
                }
              }

              > span {
                font-weight: 800;
              }
            }
          }
        }

        > .pp-contact-faq {
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: center;
          padding-top: 40px;

          @media ${deviceMax.tablet} {
            padding-top: 7px;
          }

          @media ${deviceMin.tablet} and ${deviceMax.laptopS} {
            flex-direction: column;
          }

          > .faq-icon {
            min-width: 97px;
            max-height: 125px;
            margin-right: 35px;

            @media ${deviceMax.tablet} {
              margin-right: 28px;
            }
          }

          > .faq-text {
            font-family: 'Manrope', sans-serif;
            font-weight: 400;
            font-size: 18px;
            line-height: 30px;
            letter-spacing: 0;
            color: #000000;

            @media ${deviceMax.tablet} {
              font-size: 16px;
              line-height: 24px;
            }

            > p {
              font-weight: 800;
            }

            > a {
              display: inline-block;
              text-decoration: underline;
              font-weight: 800;
            }
          }
        }
      }
    }
  }
`;